import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const PolandLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'PL',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Poland',
  SHORT_NAME: 'PL',

  DISPLAY_NAME: 'Poland (English)',
  DISPLAY_COUNTRY: 'Poland (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 51.842315,
    INITIAL_LONGITUDE: 13.8558516,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Greater Poland',
    '2': 'Kuyavian-Pomeranian',
    '3': 'Lesser Poland',
    '4': 'Lodz',
    '5': 'Lower Silesian',
    '6': 'Lublin',
    '7': 'Lubusz',
    '8': 'Masovian',
    '9': 'Opole',
    '10': 'Podlasie',
    '11': 'Pomeranian',
    '12': 'Silesian',
    '13': 'Subcarpathian',
    '14': 'Swietokrzyskie',
    '15': 'Warmian-Masurian',
    '16': 'Western-Pomeranian',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-pl/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-pl/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{2}-[0-9]{3}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default PolandLocale
